export default "__VITE_ASSET__COkznGEz__"